/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tcType: NonNullable<unknown> }} Input_Tc_Set_Button_TitleInputs */



/**
* | output |
* | --- |
* | "Insert TC {tcType}" |
*
* @param {Input_Tc_Set_Button_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_tc_set_button_title = /** @type {((inputs: Input_Tc_Set_Button_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Tc_Set_Button_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Insérer TC ${i?.tcType}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`TC ${i?.tcType} einfügen`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Inserisci TC ${i?.tcType}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Вставьте TC ${i?.tcType}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Insertar TC ${i?.tcType}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`插入 TC ${i?.tcType}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`TC ${i?.tcType} を挿入`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`TC ${i?.tcType} डालें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Inserir TC ${i?.tcType}`)
	return /** @type {LocalizedString} */ (`Insert TC ${i?.tcType}`)
});